import {
    GET_PAGE,
    SET_OPEN_LIST_PAGE,
    SET_CLOSE_LIST_PAGE,
    SET_CLOSE_POPUP_ADD_PAGE,
    SET_OPEN_POPUP_ADD_PAGE,
    SET_OPEN_POPUP_UPDATE_PAGE,
    SET_CLOSE_POPUP_UPDATE_PAGE,
} from '../../@jumbo/constants/ActionTypes';
import { API } from 'services/apiResource';
import apiServices from 'services/apiServices';
import { notificationSuccess } from './Notification';
import { fetchStart, fetchSuccess } from '../../redux/actions/Common';
import { EventName } from '@jumbo/constants/electron/EventName';
import { createLog } from './Logs';
import handleRequest from 'helpers/handleRequest';
import { v4 } from 'uuid';
const { ipcRenderer } = window.require('electron');

export const getPages = id => {
    return async dispatch => {
        handleRequest(async () => {
            dispatch(fetchStart());
            let { rows, error } = await apiServices.get(`${API.GROUP_FBS.getGroups}/${id}`);
            if (!rows) {
                throw error;
            }
            return rows;
        }, (rows) => {
            dispatch(fetchSuccess());
            dispatch({
                type: GET_PAGE,
                payload: rows,
            });
        }, dispatch);
    };
};

export const createPage = data => {
    return async dispatch => {
        handleRequest(async () => {
            dispatch(fetchStart());
            data.action_id = v4();
            let { msg, error } = await apiServices.post(API.GROUP_FBS.createGroup, data);
            if (!msg) {
                throw error;
            }
        }, () => {
            dispatch(fetchSuccess());
            dispatch(getPages(data.fb_id));
            dispatch(notificationSuccess('Tạo group thành công!'));
        }, dispatch);
    };
};

export const deleteGroup = (data, accountId) => {
    return async dispatch => {
        handleRequest(async () => {
            dispatch(fetchStart());
            let { msg, error } = await apiServices.delete(`${API.GROUP_FBS.deleteGroups}`, data);
            if (!msg) {
                throw error;
            }
        }, () => {
            dispatch(fetchSuccess());
            // dispatch(setCloseListPage());
            dispatch(notificationSuccess('Xóa thành công page!'));
        }, dispatch);
    };
};

export const listenAddGroupFB = () => {
    return dispatch => {
        ipcRenderer.on(EventName.addGroupFB, async (event, arg) => {
            handleRequest(async () => {
                dispatch(fetchStart());
                let { msg, error } = await apiServices.post(API.GROUP_FBS.createGroup, arg);
                if (!msg) {
                    throw error;
                }
            }, () => {
                dispatch(fetchSuccess());
                dispatch(notificationSuccess(`${arg.fb_id} đã lưu NHÓM "${arg.group_id}" thành công`));
            }, dispatch);
        });
    };
}

export const listenAddMultiGroupFB = () => {
    return dispatch => {
        ipcRenderer.on(EventName.addMultiGroupFB, async (event, arg) => {
            let { fb_id, account_id, groups } = arg;
            handleRequest(async () => {
                dispatch(fetchStart());
                let { msg, totalInsert, totalDelete, error } = await apiServices.post(API.GROUP_FBS.createMultiGroup, { groups });
                if (!msg) {
                    throw error;
                }
                return { totalDelete, totalInsert };
            }, ({ totalInsert, totalDelete }) => {
                dispatch(fetchSuccess());
                dispatch(notificationSuccess(`Đồng bộ nhóm của FB: ${fb_id}, đã thêm nhóm: ${totalInsert}, đã xóa: ${totalDelete}`));
                dispatch(createLog({ status: 1, message: `Đồng bộ nhóm của FB: ${fb_id}, đã thêm nhóm: ${totalInsert}, đã xóa: ${totalDelete}`, account_id }))
            }, dispatch);
        });
    };
}

export const listenDeleteNotJoinGroup = () => {
    return dispatch => {
        ipcRenderer.on(EventName.deleteNotJoinGroup, async (event, arg) => {
            let { uuid, action_id } = arg;
            handleRequest(async () => {
                dispatch(fetchStart());
                let { msg, error } = await apiServices.delete(`${API.GROUP_FBS.deleteGroups}/${uuid}/action/${action_id}`, {});
                if (!msg) {
                    throw error;
                }
            }, () => {
                dispatch(getPages(uuid));
                dispatch(notificationSuccess(`${uuid} đã xóa thành công những nhóm chưa tham gia`));
            }, dispatch);
        })
    }
}

export const setOpenListPage = () => {
    return { type: SET_OPEN_LIST_PAGE };
};
export const setCloseListPage = () => {
    return { type: SET_CLOSE_LIST_PAGE };
};
export const setClosePopupAddPage = () => {
    return { type: SET_CLOSE_POPUP_ADD_PAGE };
};
export const setOpenPopupAddPage = () => {
    return { type: SET_OPEN_POPUP_ADD_PAGE };
};
export const setClosePopupUpdatePage = () => {
    return { type: SET_CLOSE_POPUP_UPDATE_PAGE };
};
export const setOpenPopupUpdatePage = () => {
    return { type: SET_OPEN_POPUP_UPDATE_PAGE };
};
